import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/**
 * A copy-to-clipboard button.
 *
 * `navigator.clipboard` is unavailable on insecure origins, which includes
 * plain-HTTP deployments behind a proxy, so the failure is reported in the
 * button rather than left to look like a no-op.
 */
export function CopyButton({
  value,
  label = 'Copy',
  onCopied,
}: {
  value: string;
  label?: string;
  onCopied?: () => void;
}) {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);

  const copy = async () => {
    setFailed(false);
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      onCopied?.();
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setFailed(true);
    }
  };

  return (
    <button type="button" className="copy-button" onClick={copy} title={`Copy ${label}`}>
      {copied ? <Check size={15} /> : <Copy size={15} />}
      <span>{copied ? 'Copied' : failed ? 'Copy failed' : label}</span>
    </button>
  );
}
